import React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { Spinner, Icon } from "components/common";
const SuccessIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.colors.variant.success};
  `
);
const ErrorIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.colors.variant.danger};
  `
);
const STEP_KEYS = {
  createStream: "create_stream",
  startStream: "start_stream",
  createPipeline: "create_pipeline",
  setupRouting: "setup_routing",
  result: "result",
  deleteStream: "delete_stream",
  deletePipeline: "delete_pipeline",
  deleteRouting: "delete_routing",
  connectPipeline: "connect_pipeline"
};
const NAMED_STEPS = [
  "createStream",
  "startStream",
  "createPipeline",
  "deleteStream",
  "deletePipeline"
];
const ProgressMessage = ({
  stepName = void 0,
  isLoading,
  isSuccess,
  isError,
  name = void 0,
  errorMessage = void 0,
  title = void 0,
  details = void 0
}) => {
  const { t } = useTranslation("inputs");
  const text = (status) => {
    if (status === "loading" && stepName === "result") return "";
    const key = STEP_KEYS[stepName];
    return name !== void 0 && NAMED_STEPS.includes(stepName) ? t(`setup_wizard.progress.${status}.${key}_named`, { name }) : t(`setup_wizard.progress.${status}.${key}`);
  };
  if (isLoading) {
    return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Spinner, { text: title != null ? title : text("loading") }));
  }
  if (isError) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(ErrorIcon, { name: "close", title: title != null ? title : text("error") }), title != null ? title : text("error")), details || errorMessage && /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("strong", null, t("setup_wizard.progress.details")), " ", details != null ? details : errorMessage.message));
  }
  if (isSuccess) {
    return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(SuccessIcon, { name: "check", title: title != null ? title : text("success") }), title != null ? title : text("success"));
  }
  return null;
};
export default ProgressMessage;
